import { useAppSelector } from '../../../../app/hooks';
import { useGetBlocksQuery } from '../../../../services/entities/impl/blfApi/endpoints/blocks';
import { Block } from '../../../../services/entities/impl/blfApi/schemas/block';
import { selectCurrOnboardBlockID } from '../../onboardingSlice';

export const useGetCurrOnboardBlock = (): {
  currentData: Block | null;
  isLoading: boolean;
  isFetching: boolean;
} => {
  const currOnboardBlockID = useAppSelector(selectCurrOnboardBlockID);

  // Using all users query to correctly handle user mutations.
  // Mostly because of correct handling of user roles mutations.
  const {
    currentData: currBlock,
    isLoading,
    isFetching,
  } = useGetBlocksQuery(undefined, {
    selectFromResult: ({ data, isLoading, isFetching }) => {
      return {
        currentData: data?.find((block) => block.id === currOnboardBlockID),
        isLoading,
        isFetching,
      };
    },
  });

  return {
    currentData: currOnboardBlockID ? currBlock || null : null,
    isLoading,
    isFetching,
  };
};
